export default "__VITE_ASSET__b9b41cfc__"